export default "__VITE_ASSET__0e38c341__"